import { render, staticRenderFns } from "./VotingIndicators.vue?vue&type=template&id=36b7737c&"
import script from "./VotingIndicators.vue?vue&type=script&lang=js&"
export * from "./VotingIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports